export default {
	meta: {
		title: 'À propos',
		description: 'Informations et liens utiles.'
	},
	title: 'À propos',
	links: [
		{
			title: 'CNAM',
			links: [
				{
					id: 0,
					url: 'https://github.com/assurance-maladie-digital/design-system',
					name: 'Design System'
				}
			]
		},
		{
			title: 'Vue.js',
			links: [
				{
					id: 0,
					url: 'https://vuejs.org/',
					name: 'Core Docs'
				},
				{
					id: 1,
					url: 'https://forum.vuejs.org/',
					name: 'Forum'
				}
			]
		},
		{
			title: 'Vuetify',
			links: [
				{
					id: 0,
					url: 'https://vuetifyjs.com/',
					name: 'Vuetify'
				}
			]
		},
		{
			title: 'Écosystème',
			links: [
				{
					id: 0,
					url: 'http://router.vuejs.org/',
					name: 'Vue Router'
				},
				{
					id: 1,
					url: 'http://vuex.vuejs.org/',
					name: 'Vuex'
				},
				{
					id: 2,
					url: 'https://github.com/vuejs/awesome-vue',
					name: 'Awesome Vue'
				}
			]
		}
	],
	backBtn: {
		to: {
			name: 'home'
		},
		label: 'Retour'
	}
};
